import GlobalActions from "./global.actions";

const actions = {
    ...GlobalActions,
}

export default actions;